import { WebConfigProcessoFluxo } from "./webConfigProcessoFluxo.model";

export class WebIntegrFuncionalidade {
    idModulo: number;
    idFuncionalidade: number;
    nmFuncionalidade: string;
    nmPagina: string;
    icAtivo: string;
    icBlank: string;
    sgFuncionalidade: string;
    fluxoProcessos: WebConfigProcessoFluxo;
}